

export const endPoints = {
    Domains: '/domain',
    Subscriptions: '/subscription',
    KlinnicUser: '/klinnic/user',
    SendMailUpgradeClient: '/mailer/sendMailUpgradeClient',
    AddUserToDomain: '/mailer/addUserToDomain',
    ComfirmEmail: '/mailer/comfirmEmail',
    ForgottenEmail: '/mailer/forgottenEmail',
    RegisterRq: '/register'
}